import * as yup from 'yup';

export const loyaltyFormSchema = yup.object().shape({
  points: yup.number().positive().required(),
  reason: yup.string().max(100).required().default(''),
});
